import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { MixedContainerCfgUIElement } from '@/elements/containers/MixedContainer/MixedContainer';
import ComponentSwitchCfgUIElement from '@/elements/ComponentElement/ComponentSwitch';
import { MockComponentLookup } from '../mocks/MockComponentStates';
import {
  mockOptionNameOnly,
  mockOptionNameDesc,
  mockOptionCollapsed,
  mockOptionExpanded,
  mockComponentWithSwitch,
} from '../mockData';
import styles from './StyleGuideOptionText.module.css';

export const StyleGuideOptionText: React.FC = observer(function StyleGuideOptionText() {
  const [switchLookup] = useState(() => new MockComponentLookup(mockComponentWithSwitch.lookupConfig));

  return (
    <div className={styles.section}>
      {/* ================================================================== */}
      {/* SECTION 1: CONTENT VARIANTS */}
      {/* ================================================================== */}
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Content Variants</h2>
      </div>

      <div className={styles.variantGrid}>
        {/* Name only */}
        <div className={styles.variantItem}>
          <p className={styles.variantLabel}>Name</p>
          <div className={styles.demo}>
            <MixedContainerCfgUIElement viewElement={mockOptionNameOnly} childrenItems={[]} />
          </div>
        </div>

        {/* Name + Description */}
        <div className={styles.variantItem}>
          <p className={styles.variantLabel}>Name+Description</p>
          <div className={styles.demo}>
            <MixedContainerCfgUIElement viewElement={mockOptionNameDesc} childrenItems={[]} />
          </div>
        </div>

        {/* Name + Description + Switch */}
        <div className={styles.variantItem}>
          <p className={styles.variantLabel}>Name+Description+Switch</p>
          <div className={styles.demo}>
            <ComponentSwitchCfgUIElement
              lookup={switchLookup as any}
              viewElement={mockComponentWithSwitch.viewElement}
            />
          </div>
        </div>

        {/* Collapsed option */}
        <div className={styles.variantItem}>
          <p className={styles.variantLabel}>Collapsed option</p>
          <div className={styles.demo}>
            <MixedContainerCfgUIElement viewElement={mockOptionCollapsed} childrenItems={[]} />
          </div>
        </div>

        {/* Expanded option */}
        <div className={styles.variantItem}>
          <p className={styles.variantLabel}>Expanded option</p>
          <div className={styles.demo}>
            <MixedContainerCfgUIElement viewElement={mockOptionExpanded} childrenItems={[]} />
          </div>
        </div>
      </div>

      {/* ================================================================== */}
      {/* SECTION 2: NESTING LEVELS */}
      {/* ================================================================== */}
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Nesting Levels</h2>
      </div>

      <div className={styles.variantGrid}>
        {/* 1st level */}
        <div className={styles.variantItem}>
          <p className={styles.variantLabel}>1st level</p>
          <div className={styles.demo}>
            <MixedContainerCfgUIElement
              viewElement={{ ...mockOptionNameDesc, id: 'option-level-1', _parentLevel: 1 } as any}
              childrenItems={[]}
            />
          </div>
        </div>

        {/* 2nd level */}
        <div className={styles.variantItem}>
          <p className={styles.variantLabel}>2nd level</p>
          <div className={styles.demo}>
            <MixedContainerCfgUIElement
              viewElement={{ ...mockOptionNameDesc, id: 'option-level-2', _parentLevel: 2 } as any}
              childrenItems={[]}
            />
          </div>
        </div>

        {/* 3rd level */}
        <div className={styles.variantItem}>
          <p className={styles.variantLabel}>3rd level</p>
          <div className={styles.demo}>
            <MixedContainerCfgUIElement
              viewElement={{ ...mockOptionNameDesc, id: 'option-level-3', _parentLevel: 3 } as any}
              childrenItems={[]}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
